import React from 'react';
import { background, wrap } from './style';

function Spiner() {
  return (
    <div css={background}>
      <div css={wrap}></div>
    </div>
  );
}

export default Spiner;
